import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import InvoiceHiredInformation from "./InvoiceHiredInformation";
import ContractTerms from "./ContractTerms";

const AnticipationProposal = ({ setOpen, open, data }) => {
  return (
    <Box
      style={{
        borderRadius: "8px 8px 8px 8px",
      }}
    >
      <Box
        display={"flex"}
        sx={{
          borderRadius: "4px 4px 0px 0px",
          padding: "20px 24px 16px 24px",
          background: "linear-gradient(90.52deg, #626DFD 1.01%, #7232FB 100%)",
        }}
        alignItems={"center"}
      >
        <Typography
          fontWeight={400}
          fontSize={"18px"}
          sx={{
            color: "white",
          }}
          component="div"
        >
          •{" "}
          {data.receivables?.length > 1
            ? `${data.receivables?.length} Notas Fiscais carregadas`
            : `${data.receivables?.length} Nota Fiscal carregada`}
        </Typography>

        <Box sx={{ flexGrow: 1 }} />

        <Box display={"flex"} gap={2} maxWidth={true}>
          <Box>
            <Typography
              fontWeight={400}
              fontSize={"18px"}
              sx={{
                color: "white",
              }}
              component="div"
            >
              {data?.summary?.numberOfApprovedReceivables > 1
                ? `${data?.summary?.numberOfApprovedReceivables} aprovadas`
                : `${data?.summary?.numberOfApprovedReceivables} aprovada`}
            </Typography>
          </Box>

          <Divider
            orientation="vertical"
            style={{ background: "#7363FF" }}
            flexItem
          />

          <Typography
            fontWeight={400}
            fontSize={"18px"}
            sx={{
              color: "white",
            }}
            component="div"
          >
            {data?.summary?.numberOfRejectedReceivables > 1
              ? `${data?.summary?.numberOfRejectedReceivables} rejeitadas`
              : `${data?.summary?.numberOfRejectedReceivables} rejeitada`}
          </Typography>
        </Box>

        <IconButton
          disableElevation
          disableRipple
          size="small"
          sx={{
            ml: 1,
            "&.MuiButtonBase-root:hover": {
              bgcolor: "transparent",
            },
          }}
          aria-label="expand row"
          onClick={() => setOpen(!open)}
        >
          {open ? (
            <KeyboardArrowUp
              sx={{
                color: "white",
              }}
            />
          ) : (
            <KeyboardArrowDown
              sx={{
                color: "white",
              }}
            />
          )}
        </IconButton>
      </Box>

      <Box
        sx={{
          background: "linear-gradient(90.52deg, #626DFD 1.01%, #7232FB 100%)",
        }}
      >
        <InvoiceHiredInformation open={open} data={data} />
      </Box>

      {data.contractTerms !== undefined && (
        <ContractTerms contractTerms={data.contractTerms} />
      )}
    </Box>
  );
};

export default AnticipationProposal;
